import type { ComponentType } from 'react';

import { CreditCardIcon, FlagIcon, GovBuildingIcon, GroupIcon, MediaIcon, ShareIcon } from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export type SupporterActionType = Readonly<{
	Icon: ComponentType<{ size?: number }>;
	title: TranslationKey;
	body: TranslationKey;
}>;

export const SUPPORTER_ACTIONS: ReadonlyArray<SupporterActionType & Readonly<{ id: string }>> = [
	{
		id: 'chip_in',
		Icon: CreditCardIcon,
		title: translationKey('corgi.vision_page.supporters.actions.chip_in.title'),
		body: translationKey('corgi.vision_page.supporters.actions.chip_in.body'),
	},
	{
		id: 'share',
		Icon: ShareIcon,
		title: translationKey('corgi.vision_page.supporters.actions.share.title'),
		body: translationKey('corgi.vision_page.supporters.actions.share.body'),
	},
	{
		id: 'record_story',
		Icon: MediaIcon,
		title: translationKey('corgi.vision_page.supporters.actions.record_story.title'),
		body: translationKey('corgi.vision_page.supporters.actions.record_story.body'),
	},
	{
		id: 'yard_signs',
		Icon: FlagIcon,
		title: translationKey('corgi.vision_page.supporters.actions.yard_signs.title'),
		body: translationKey('corgi.vision_page.supporters.actions.yard_signs.body'),
	},
	{
		id: 'organize',
		Icon: GroupIcon,
		title: translationKey('corgi.vision_page.supporters.actions.organize.title'),
		body: translationKey('corgi.vision_page.supporters.actions.organize.body'),
	},
	{
		id: 'city_council',
		Icon: GovBuildingIcon,
		title: translationKey('corgi.vision_page.supporters.actions.city_council.title'),
		body: translationKey('corgi.vision_page.supporters.actions.city_council.body'),
	},
];
